import React from "react";
import { useTranslation } from "react-i18next";
import { ModalConfirm } from "../../ModalConfirm";
import { getErrorMessages } from "../../../Utils";

// The dialog an action (delete, export, save from a list) raises when it fails.
// `message` overrides the text for errors the page explains in its own words.
// ModalConfirm runs its description through t(), and t() of an array shows only
// the first key, so the messages are joined here instead.
const ErrorDialog = ({
  open,
  error,
  message,
  onClose,
  title = "common.errors.label",
  "data-testid": dataTestId,
}) => {
  const { t } = useTranslation();
  const text = message || getErrorMessages(error, t).join(" ");

  return (
    <ModalConfirm
      open={open}
      type="ALERT"
      // OK and the backdrop both arrive here as setOpen(false); passing
      // onClose as onConfirm too would run it twice.
      setOpen={(next) => {
        if (!next) onClose?.();
      }}
      title={title}
      description={text || "common.errors.data"}
      data-testid={dataTestId}
    />
  );
};

export default ErrorDialog;
